import { RawProfile } from "./profileService";

export type TableRow = {
  id: string;
  name: string;
  profile?: string | null;
  email?: string | null;
  mobile_number?: string | null;
  address?: { line1?: string; city?: string; state?: string; zip?: string } | undefined;
  joinedAt?: string | undefined;
  role?: "Customer" | "Employee" | "Unknown";
  raw: RawProfile;
};

const MEDIA_BASE = process.env.REACT_APP_MEDIA_BASE || process.env.REACT_APP_API_BASE || "";

export function getImageUrl(path?: string | null) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const base = MEDIA_BASE.replace(/\/+$/, "");
  const p = path.replace(/^\/+/, "");
  return base ? `${base}/${p}` : `/${p}`;
}

export function inferRole(p: RawProfile): TableRow["role"] {
  if (p.employee_code) return "Employee";
  if (p.customer_code) return "Customer";
  return "Unknown";
}

export function mapProfileToRow(p: RawProfile): TableRow {
  const name = [p.first_name, p.last_name].filter(Boolean).join(" ").trim() || p.customer_code || p.employee_code || `#${p.profile_id}`;

  // address: try first address_bank_details item if exists
  const addrRaw = (p.address_bank_details && p.address_bank_details[0]) || null;
  const address = addrRaw
    ? {
        line1: addrRaw.address_line1 ?? addrRaw.address ?? undefined,
        city: addrRaw.city ?? undefined,
        state: addrRaw.state ?? undefined,
        zip: addrRaw.zip_code ?? undefined,
      }
    : undefined;

  return {
    id: String(p.profile_id),
    name,
    profile: getImageUrl(p.profile_photo_url ?? p.profile_photo ?? null),
    email: p?.email ?? undefined,
    mobile_number: p?.mobile_number ?? undefined,
    address,
    joinedAt: p.created_at ? new Date(p.created_at).toLocaleDateString() : undefined,
    role: inferRole(p),
    raw: p,
  };
}

export const flattenProfile = (profile: RawProfile) => ({
  ...profile,
  username: profile.login?.username ?? "",
  email: profile?.email ?? "",
  mobile_number: profile?.mobile_number ?? "",
  role: profile.login?.role ?? "",
});
